import { useMemo } from 'react';
import useAlarms, {
  IUseAlarmsProps,
} from '../../../../../../../../redux/alarm/hooks/useAlarms';
import { LOW_TEMP_ALARM_EVENT } from '../LowTemp/useLowTempAlarms';
import { excludedEventIds } from '../../../../../../../../redux/alarm/Alarm.model';

export const excludedEventIdsFlexeserveDeviceError = JSON.stringify([
  ...excludedEventIds,
  LOW_TEMP_ALARM_EVENT,
]);
function useFelxeserveDeviceError(props: IUseAlarmsProps) {
  const { typeRequest, groupId, workspaceId, params } = props;
  const memoizedParams = useMemo(
    () => ({
      ...params,
      excluded_event_ids: excludedEventIdsFlexeserveDeviceError,
    }),
    [params]
  );
  return useAlarms({
    typeRequest,
    groupId,
    workspaceId,
    params: memoizedParams,
  });
}

export default useFelxeserveDeviceError;
